var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mr-4" },
    [
      _vm.filepath
        ? [
            _c("img", {
              staticClass: "inline-block h-16 w-16 rounded-full",
              attrs: { src: _vm.filepath, alt: "" },
            }),
          ]
        : [
            _c(
              "span",
              {
                staticClass:
                  "inline-flex items-center justify-center h-16 w-16 rounded-full bg-primary-500",
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "text-lg font-medium leading-none text-white",
                  },
                  [_vm._v(_vm._s(_vm.initial))]
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }